import { Row, Col, Form, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { Field, Formik } from 'formik';
import AutoSuggestionSelectComponent from 'src/Components/auto-suggestion-select/Select';
import useMyPublishMessage from '../hook/useMyPublishMessage';
import RichtextEditor from 'src/Admin/components/ConfigurePages/RichtextEditor';
import MultipleFileUpload from 'src/Components/fileupload/MultipleFileUpload';
import { Fragment } from 'react';
import FileInfo from 'src/Components/fileupload/FileInfo';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import BlobEmployerLocationSelection from '../BlobEmployerLocation/BlobEmployerLocationSelection';
import PermissionSelection from '../Permissions/PermissionSelection';
import { ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import Brokers from '../Brokers/Brokers';
import DoctorSelection from '../Provider/DoctorSelection';
import FacilitySelection from '../Provider/FacilitySelection';
import Checkbox from 'src/Admin/components/common/Checkbox';
import DatePicker from '../../../common/DatePicker';
import { useSelector } from 'react-redux';

const PublishMessageForm = ({ userTypeSelectedValue = 'Member' }) => {
  const {
    MESSAGE_TYPE_OPTIONS,
    messageType,
    setMessageType,
    setMessageTitle,
    getMessageHtml,
    durationFrom,
    durationTo,
    setDurationFrom,
    setDurationTo,
    files,
    setFiles,
    blobCheck,
    permissionCheck,
    brokersCheck,
    providersCheck,
    publishMessageHandler,
    setSendToBlobDataHandler,
    setSendToPermissionDataHandler,
    setMultiSelectFlag,
    selectedBrokerData,
    setSelectedBrokerData,
    selectedEmployerData,
    isBlobEmpLocFlow,
    renderSendToCheckboxes,
    sendEmail,
    setSendEmail,

    filesLoader,
    isComingFromPortalTiPortal,
    formFields,
    schema,
    handleDeleteAttachment,
    sendToPermissionData,
    selectedBlobData,
    messageContent,
    selectedDoctorsData,
    setSelectedDoctorsData,
    hasDoctors,
    setHasDoctors,
    hasFacilities,
    setHasFacilities,
    selectedFacilityData,
    setSelectedFacilityData,
  } = useMyPublishMessage(userTypeSelectedValue);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const today = new Date();
  const minDateForExpiry =
    today.getFullYear() +
    '-' +
    (today.getMonth() + 1 > 9
      ? today.getMonth() + 1
      : '0' + (today.getMonth() + 1)) +
    '-' +
    today.getDate();

  const { Default_Time_Format } = useSelector(
    ({ app }) => app.appConfigs.Time_Setting || 'MM-dd-yyyy',
  );

  const handleDateChange = (dates) => {
    if (moment(dates[0]).isValid()) {
      setDurationFrom(dates[0]);
    }
    if (moment(dates[1]).isValid() && moment(dates[0]) < moment(dates[1])) {
      setDurationTo(dates[1]);
    }
  };

  return (
    <div className="form-wrapper">
      <Card className="p-4">
        <Formik
          validationSchema={schema}
          initialValues={{
            messageType: null,
            messageSentTo: [
              userTypeSelectedValue === 'Provider'
                ? 'Providers'
                : 'blockOfBusiness',
            ],
            messsagTitle: null,
            durationFrom: null,
            durationTo: null,
            files: [],
          }}
          onSubmit={(values, errors) => {
            console.log('errorserrors', errors);
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldTouched,
            setFieldValue,
            values,
            touched,
            errors,
            resetForm,
          }) => (
            <Form
              className="PublishMessage-Container"
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(e);
                console.log('publishMessageHandler_', e, errors);
                const myErrorObj = { ...errors };
                if (blobCheck && selectedBlobData?.length === 0) {
                  if (
                    ((isBlobEmpLocFlow === false &&
                      userTypeSelectedValue === 'Broker') ||
                      userTypeSelectedValue === 'Client') &&
                    selectedEmployerData?.length > 0
                  ) {
                    delete myErrorObj.myBlobData;
                  } else {
                    myErrorObj.myBlobData = 'At least 1 blob should be selcted';
                  }
                } else {
                  delete myErrorObj.myBlobData;
                }
                if (permissionCheck && sendToPermissionData?.length === 0) {
                  myErrorObj.myPermissionData =
                    'At least 1 permission should be selcted';
                } else {
                  delete myErrorObj.myPermissionData;
                }
                publishMessageHandler(values, myErrorObj, resetForm);
              }}
            >
              <Form.Group className="form-block" controlId="Publish-Message">
                <Row className="message-type">
                  <Col md={12} lg={12} sm={12}>
                    <Form.Group controlId="messageType">
                      <Form.Label className="publishmessage-labels">
                        Message Template/Type
                        <span
                          className="publish-msg-required-field"
                          aria-hidden={true}
                        >
                          *
                        </span>
                      </Form.Label>
                      <AutoSuggestionSelectComponent
                        options={MESSAGE_TYPE_OPTIONS}
                        name="messageType"
                        components={{ IndicatorSeparator: () => null }}
                        value={messageType}
                        onChange={(e) => {
                          const event = {
                            target: { name: 'messageType', value: e },
                          };
                          handleChange(event);
                          setMessageType(e);
                          console.log('messageType', e);
                        }}
                        onBlur={() => {
                          handleBlur({ target: { name: 'messageType' } });
                        }}
                        fieldTouch={setFieldTouched}
                        isSearchable={false}
                        inputClassName={
                          touched.messageType && errors.messageType
                            ? 'invalid-error'
                            : ''
                        }
                        id="messageType"
                        labelText={'filter dropdown, messageType'}
                        //isRequired={true}
                        isInvalid={touched.messageType && errors.messageType}
                        //required={true}
                        valid={errors.messageType ? true : null}
                        describedby="err_messageType"
                      />
                      <span
                        className="invalid-error"
                        type="invalid"
                        aria-live="polite"
                        id="err_messageType"
                        role="alert"
                      >
                        {touched.messageType && errors.messageType}
                      </span>
                    </Form.Group>
                  </Col>
                </Row>
              </Form.Group>
              <div className="fields-saperator" />
              <div className="message-blob-permission-plan">
                <Form.Group
                  controlId="messageSentTo"
                  aria-describedby="messageSentTo"
                >
                  <h2 className="section-heading">Send To</h2>
                  <p className="section-sub-heading">
                    Select the group of member to send the message.
                    <span
                      className="publish-msg-required-field"
                      aria-hidden={true}
                    >
                      *
                    </span>
                  </p>
                  <div>
                    <Field
                      name="messageSentTo"
                      render={({ field, form }) => (
                        <>
                          <div className="checkbox-selection-wrapper checkbox-container">
                            {renderSendToCheckboxes({
                              field,
                              setFieldTouched,
                              form,
                            })}
                          </div>
                        </>
                      )}
                    />
                    <span className="invalid-error" type="invalid">
                      {touched.messageSentTo && errors.messageSentTo}
                    </span>
                  </div>
                  {/*<Checkbox
              inline
              key="publish-new-message-plans"
              label=" Plans"
              className="d-none"
              value={plansCheck}
              id="publish-new-message-plans"
              name="publish-new-message-plans"
              onChange={(e) => setPlansCheck(e.target.checked)}
              checked={plansCheck}
            /> */}
                  <div className="checkmark-data">
                    {blobCheck && (
                      <>
                        <BlobEmployerLocationSelection
                          setSendToBlobDataHandler={setSendToBlobDataHandler}
                          formFields={formFields}
                          isBlobEmpLocFlow={isBlobEmpLocFlow}
                          userTypeSelectedValue={userTypeSelectedValue}
                        />
                        {touched.messageSentTo &&
                          selectedBlobData?.length === 0 &&
                          (((isBlobEmpLocFlow === false &&
                            userTypeSelectedValue === 'Broker') ||
                            userTypeSelectedValue === 'Client') &&
                          Object.keys(selectedEmployerData)?.length > 0 ? (
                            ''
                          ) : (
                            <span className="invalid-error" type="invalid">
                              {`At least 1 ${
                                ((isBlobEmpLocFlow === false &&
                                  userTypeSelectedValue === 'Broker') ||
                                  userTypeSelectedValue === 'Client') &&
                                Object.keys(selectedEmployerData)?.length === 0
                                  ? 'Employer'
                                  : 'Block of Business'
                              } should be selected.`}
                            </span>
                          ))}
                      </>
                    )}
                    {permissionCheck && (
                      <>
                        <PermissionSelection
                          setSendToPermissionDataHandler={
                            setSendToPermissionDataHandler
                          }
                          formFields={formFields}
                        />
                        {touched.messageSentTo &&
                          sendToPermissionData?.length === 0 && (
                            <span className="invalid-error" type="invalid">
                              At least 1 permission should be selected.
                            </span>
                          )}
                      </>
                    )}
                    {brokersCheck && (
                      <div className="brokers-selection-container">
                        <Brokers
                          onSelectedBrokersLists={(brokers) => {
                            console.log('brokers', brokers);
                            setSelectedBrokerData(brokers);
                          }}
                          formFields={formFields}
                          selectedBrokerData={selectedBrokerData}
                        />
                      </div>
                    )}
                    {providersCheck && (
                      <>
                        {!hasFacilities && (
                          <DoctorSelection
                            hasDoctors={hasDoctors}
                            setHasDoctors={setHasDoctors}
                            selectedDoctorsData={selectedDoctorsData}
                            setSelectedDoctorsData={setSelectedDoctorsData}
                          />
                        )}

                        {!hasDoctors && (
                          <FacilitySelection
                            setHasFacilities={setHasFacilities}
                            formFields={formFields}
                            selectedFacilityData={selectedFacilityData}
                            setSelectedFacilityData={setSelectedFacilityData}
                          />
                        )}
                      </>
                    )}
                    {/*#TODO : For Plans we will take it up later as per Amit. */}
                  </div>
                </Form.Group>
              </div>
              <div className="fields-saperator" />
              <Row>
                <Col md={12} lg={12} sm={12}>
                  <Form.Group controlId="messsagTitle">
                    <Form.Label className="publishmessage-labels">
                      Message Title
                      <span
                        className="publish-msg-required-field"
                        aria-hidden={true}
                      >
                        *
                      </span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="messsagTitle"
                      placeholder=""
                      className="messsagTitle-class"
                      value={values.messsagTitle ?? ''}
                      spellCheck="off"
                      autoCorrect="off"
                      autoComplete="off"
                      autoFocus={false}
                      onBlur={(e) => {
                        handleBlur(e);
                        const storeTitle = e.currentTarget.value.trim();
                        setFieldValue('messsagTitle', storeTitle);
                      }}
                      onChange={(e) => {
                        setFieldTouched('messsagTitle');
                        handleChange(e);
                        setMessageTitle(e?.target?.value);
                      }}
                      isInvalid={touched.messsagTitle && errors.messsagTitle}
                      aria-required={true}
                      aria-invalid={errors.messsagTitle ? true : null}
                      aria-describedby="err_messsagTitle"
                    />
                    <span className="invalid-error" type="invalid">
                      {touched.messsagTitle && errors.messsagTitle}
                    </span>
                  </Form.Group>
                </Col>
              </Row>
              <div className="message-content">
                <RichtextEditor
                  value={messageContent}
                  onSave={getMessageHtml}
                  autoFocus={false}
                  displayExtraToolbarOptions={['LINK_BUTTONS']}
                />
              </div>
              <div className="mt-4">
                <Checkbox
                  inline
                  key="send-email-for-bulk-message"
                  label=" Send a message as an email?"
                  className="d-none"
                  value={sendEmail ? true : false}
                  id="send-email-for-bulk-message"
                  name="send-email-for-bulk-message"
                  onChange={(e) => {
                    setSendEmail(e?.target?.checked);
                  }}
                  checked={sendEmail}
                />
              </div>
              <div className="fields-saperator" />
              <div className="message-duration">
                <h2 className="section-heading mb-4">Duration</h2>
                <div className="my-date-picker-container">
                  <div className="date-picker-wrapper">
                    <Form.Group controlId="durationFrom">
                      <Form.Label className="publishmessage-labels">
                        Effective Duration
                      </Form.Label>

                      <DatePicker
                        allowFutureDates={true}
                        selectsRange={true}
                        startDate={durationFrom ?? null}
                        endDate={durationTo ?? null}
                        onChange={handleDateChange}
                        onChangeRaw={(e) => {
                          if (e.target.value) {
                            const dates = e.target.value
                              .split(' - ')
                              .map((date) => {
                                const d = new Date(date);
                                return d;
                              });
                            handleDateChange(dates);
                          }
                        }}
                        showIcon={true}
                        placeholder={
                          Default_Time_Format + ' - ' + Default_Time_Format
                        }
                      />

                      {/*<Form.Control
                        type="date"
                        name="durationFrom"
                        placeholder="'MM/DD/YYYY'"
                        className="durationFrom-class"
                        value={values.durationFrom ?? ''}
                        spellCheck="off"
                        autoCorrect="off"
                        autoComplete="off"
                        autoFocus={false}
                        onBlur={(e) => {
                          handleBlur(e);
                          const storeTitle = e.currentTarget.value.trim();
                          setFieldValue('durationFrom', storeTitle);
                        }}
                        onChange={(e) => {
                          setFieldTouched('durationFrom');
                          handleChange(e);
                          setDurationFrom(e.target.value);
                        }}
                        isInvalid={touched.durationFrom && errors.durationFrom}
                        aria-required={true}
                        aria-invalid={errors.durationFrom ? true : null}
                        aria-describedby="err_durationFrom"
                      />
                      <span className="invalid-error" type="invalid">
                        {touched.durationFrom && errors.durationFrom}
                      </span> */}
                    </Form.Group>
                  </div>

                  {/*<div className="date-picker-wrapper">
                    <Form.Group controlId="messsagTitle">
                      <Form.Label className="publishmessage-labels">
                        Expiry

                      </Form.Label>
                      <Form.Control
                        min={minDateForExpiry}
                        type="date"
                        name="durationTo"
                        placeholder="'MM/DD/YYYY'"
                        className="durationTo-class"
                        value={values.durationTo ?? ''}
                        spellCheck="off"
                        autoCorrect="off"
                        autoComplete="off"
                        autoFocus={false}
                        onBlur={(e) => {
                          handleBlur(e);
                          const storeTitle = e.currentTarget.value.trim();
                          setFieldValue('durationTo', storeTitle);
                        }}
                        onChange={(e) => {
                          setFieldTouched('durationTo');
                          handleChange(e);
                          setDurationTo(e.target.value);
                        }}
                        isInvalid={touched.durationTo && errors.durationTo}
                        aria-required={true}
                        aria-invalid={errors.durationTo ? true : null}
                        aria-describedby="err_durationTo"
                      />
                      <span className="invalid-error" type="invalid">
                        {touched.durationTo && errors.durationTo}
                      </span>
                    </Form.Group>
                  </div> */}
                </div>
              </div>
              <div className="fields-saperator" />
              <div className="message-attachments mb-4">
                <h2 className="section-heading mb-4">Attachment</h2>
                <div>
                  <MultipleFileUpload
                    className={files.length <= 0 ? '' : ''}
                    files={files}
                    setFiles={setFiles}
                    name="file"
                    setFieldValue={(e) => console.log('e :', e)}
                    setMultiSelectFlag={setMultiSelectFlag}
                  />

                  {files && files.length > 0 ? (
                    ''
                  ) : (
                    <span className="sr-only">error</span>
                  )}
                  {files.length > 0 ? (
                    <div
                      className="sr-only"
                      role="heading"
                      aria-level={1}
                      tabIndex={0}
                    ></div>
                  ) : (
                    ''
                  )}
                  <div>
                    {files &&
                      files.map((item, index) => {
                        return (
                          <Fragment key={index}>
                            <FileInfo
                              files={files}
                              setFiles={setFiles}
                              fileDetails={item}
                              filesLoader={filesLoader}
                              setFieldValue={(e) => console.log('e :', e)}
                              readFileSize={true}
                              fileUploadStatus={item?.uploadStatus}
                              fileProgress={item?.uploadPercent}
                              isComingFromPortalTiPortal={
                                isComingFromPortalTiPortal
                              }
                              handleDeleteAttachment={handleDeleteAttachment}
                            />
                          </Fragment>
                        );
                      })}
                  </div>
                </div>
              </div>
              <div className="submit-controls">
                <div>
                  <button
                    onClick={() =>
                      navigate('/admin/Messages-Documents', {
                        state: { comingFrom: 'publish-new-message' },
                      })
                    }
                    className="cancel-btn border-0 bg-transparent"
                    role="button"
                    aria-label="Click on cancel to go to documents list page"
                    tabIndex={0}
                  >
                    {t('member.upload_document.cancel')}
                  </button>
                </div>
                <div>
                  <GenericButton type="submit" variant="primary">
                    PUBLISH
                  </GenericButton>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Card>
      <div>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </div>
  );
};

export default PublishMessageForm;
